import { defineStore } from 'pinia'

import state from './state'
import getters from './getters'
import actions from './actions'

const usePowerBiExportsStore = defineStore('powerBiExports', {
  state,
  getters,
  actions
})

export default usePowerBiExportsStore
